import { AnalyticsEvent } from "./analyticsEvent";

class NewsLetterFailureEvent extends AnalyticsEvent {
    public readonly errorCondition: string;
    constructor(errorCondition: string) {
        super();
        this.errorCondition = errorCondition.replace(/(\:\s+)/gi, ":").replace(/(\s+)/gi, "_").toLowerCase();
    }
}
export { NewsLetterFailureEvent }